import { useAppSelector } from "integrations/redux/hooks"
import { useWeatherHeatmapOpacity, selectWeatherTimeline } from "features/map/control/selectors"
import { PrecipitationHeatmapLayer } from "./PrecipitationHeatmapLayer"
import { createNoCoverageLayer } from "../shared/NoCoverageLayer"
import { createTileSource } from "../series/weatherTileSource"
import { useDisplayFrame, useWeatherSeries } from "../series/weatherSeries"

const source = createTileSource("precipitation")

export const usePrecipitationLayer = () => {
    const series = useWeatherSeries("precipitation", source)
    const { currentTime } = useAppSelector(selectWeatherTimeline)
    const opacity = useWeatherHeatmapOpacity()
    const frame = useDisplayFrame("precipitation", series, currentTime)

    if (!series) return { layer: null }

    if (!series.hasCoverage) {
        return { layer: createNoCoverageLayer(series.bounds, "PrecipitationNoCoverageLayer") }
    }

    if (!frame) return { layer: null }

    return {
        layer: new PrecipitationHeatmapLayer({
            id: "PrecipitationHeatmapLayer",
            imageA: frame.imageA,
            imageB: frame.imageB,
            imageWeight: frame.imageWeight,
            bounds: frame.bounds,
            opacity,
        }),
    }
}
